<template>
  <v-container>
  <v-layout justify-center>
    <v-flex md10>
      <v-layout row wrap>
        <v-flex md12>
          <v-img src="static/surfandscan_titel.png">
            <v-layout pa-2 column fill-height class="lightbox black--text">
              <v-spacer></v-spacer>
              <v-flex shrink>
                <div class="display-1 surfandscanstyletitle font-weight-bold mb-3">surf<span style="color:#71cbf4">and</span>scan</div>
                <div class="subheading grey--text hidden-xs-only">surfen, scannen, finden, fertig <br>
                  Ihr Weg aus dem Papierchaos</div>
                <div class="body-2 grey--text hidden-sm-and-up">surfen, scannen, finden, fertig <br>
                  Ihr Weg aus dem Papierchaos</div>
                <v-flex xs5 sm4 md4 offset-xs0>
                <v-btn outline color="blue darken-4" class="text-none mt-4" small block @click="gotoDownload">Jetzt kostenlos testen</v-btn>
                </v-flex>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
          </v-img>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6 md6>
          <v-card dark tile flat color="blue-grey lighten-2" height="380px">
            <v-layout align-center justify-center>
            <v-flex xs8 sm10 md8 class="mt-5">
            <v-img src="static/surfandscan_fragezeichen.png">
            </v-img>
            </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-card dark tile flat color="blue-grey lighten-2" height="380px">
            <v-layout align-center justify-center>
              <div>
              <span class="display-4 surfandscanfont mr-2">&bdquo;</span>
              </div>
                <div class="headline surfandscanfont mt-4">Kannst du mal eben<br>
              etwas einscannen?</div>
              <div>
                <span class="display-4 surfandscanfont">&ldquo;</span>
              </div>
            </v-layout>
            <v-layout align-center justify-center>
            <div class="sizefont22 surfandscanfont mt-4">
              • Blatt richtig herum einlegen <br>
              • Scanner Software suchen <br>
              • Scanner wählen <br>
              • Datei format wählen <br>
              • Scannen <br>
              • Speichern <br>
              • Datei suchen <br>
              • …
            </div>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm12 md12>
          <v-card flat color="#71cbf4">
          <div class="diagonal">
          </div>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm6 md6>
          <v-card dark tile flat color="#71cbf4" height="380px">
            <v-layout align-center justify-center>
              <div>
                <span class="display-4 surfandscanfont mr-2">&bdquo;</span>
              </div>
              <div class="headline surfandscanfont mt-4">Mit surfandscan <br>
                scanne ich mal eben</div>
              <div>
                <span class="display-4 surfandscanfont">&ldquo;</span>
              </div>
            </v-layout>
            <v-layout align-center justify-center>
              <div class="sizefont22 surfandscanfont mt-4">
                • Blatt einlegen – egal wie rum <br>
                • surfen <br>
                • scannen <br>
                • finden <br>
                • fertig <br>
              </div>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-card dark tile flat color="#71cbf4" height="380px">
            <v-layout justify-center>
              <v-flex xs8 sm10 md8 class="">
                <v-img src="static/surfandscan_idee.png">
                </v-img>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="hidden-xs-only">
        <v-flex md12>
          <v-img src="static/SurfandScan_Vorteile.png">
          </v-img>
        </v-flex>
      </v-layout>

      <v-layout row wrap class="hidden-sm-and-up">
        <v-flex xs12>
          <v-img src="static/SurfandScan_Vorteile_mobil.png">
          </v-img>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm12 md12>
          <v-card flat color="#71cbf4">
            <div class="diagonalwhite">
            </div>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card dark tile flat color="#71cbf4" height="300px">
            <v-layout align-center justify-center>
              <div style="margin-top: 20px">
                <span class="display-4 surfandscanfont mr-2">&bdquo;</span>
              </div>
              <div class="headline surfandscanfont mt-4">Mit surfandscan unterstützen <br>
                wir die Digitale Transformation.<br> Schritt für Schritt entkommen wir <br>
                so der Flut des Papierkrams.<br>
              <span class="body-1">Matthias Ebel, Geschäftsführer edologic GmbH</span>
              </div>
              <div style="margin-bottom: 70px">
                <span class="display-4 surfandscanfont">&ldquo;</span>
              </div>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 sm12 md12>
          <v-card flat color="#71cbf4">
            <div class="diagonalblue">
            </div>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card dark tile flat color="#0e71b8" height="300px">
            <v-layout align-center justify-center>
              <div class="display-1 white--text surfandscanfont font-weight-bold mb-3">surf<span style="color:#71cbf4">and</span>scan für jedermann</div>
            </v-layout>
            <v-layout align-center justify-center>
              <div class="body-2 surfandscanfont white--text">Lassen auch Sie sich von surfandscan überzeugen.</div>
            </v-layout>
            <v-layout align-center justify-center>
              <div class="headline surfandscanfont mt-4 font-weight-light white--text">Jetzt kostenlos testen.</div>
            </v-layout>
            <v-layout align-center justify-center class="ma-4"  id="download">
              <v-btn color="white" class="text-none mt-4 mr-5 blue--text" @click="downloadMac">Download für Mac</v-btn>
                <v-btn color="white" class="text-none mt-4 ml-5 blue--text" @click="downloadWindows">Download für Windows</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-card color="white" flat min-height="300px">
            <v-layout row justify-space-around wrap class="mt-5">
              <v-flex xs11 sm8 md3>
                <v-card color="transparent" flat class="fontgrey">
                  <v-card-title class="font-weight-bold body-2">Kontakt</v-card-title>
                  <v-card-text>
                    edologic GmbH <br>
                    In der Hardt 3<br>
                    42399 Wuppertal<br>
                    <br><br>
                    <a href="https://www.edologic.de" style="text-decoration: none">www.edologic.de </a><br>
                    <a href="mailto:info@edologic.de" style="text-decoration: none">info@edologic.de</a>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs11 sm8 md3>
                <v-card color="transparent" flat class="fontgrey">
                  <v-card-title class="font-weight-bold body-2">Informationen</v-card-title>
                  <v-card-text>
                    <a href="https://www.edologic.de/impressum" style="text-decoration: none">Impressum </a> <br>
                    <a href="https://www.edologic.de/impressum" style="text-decoration: none">AGB</a><br>
                    <a href="https://www.edologic.de/datenschutz" style="text-decoration: none">Datenschutz</a><br>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs11 sm8 md3>
                <v-card color="transparent" flat class="fontgrey">
                  <v-card-title class="font-weight-bold body-2">Download</v-card-title>
                  <v-card-text>
                    <a href="https://www.edologic.de/impressum" style="text-decoration: none" @click="downloadMac">surfandscan für Mac </a> <br>
                    <a href="https://www.edologic.de/impressum" style="text-decoration: none" @click="downloadWindows">surfandscan für Windows</a><br>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-footer color="#707070" class="pa-3">
        <v-spacer></v-spacer>
        <div>&copy; {{ new Date().getFullYear() }} edologic. All Rights Reserved.</div>
      </v-footer>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'
import $ from 'jquery'
export default {
  name: 'SasOne',
  components: {},
  data () {
    return {
    }
  },
  methods: {
    downloadMac: function () {
      window.open('https://www.edologic.de/demo/SurfAndScanInstaller.zip', '_new')
    },
    downloadWindows: function () {
      window.open('https://www.edologic.de/demo/SurfAndScanInstaller.zip', '_new')
    },
    gotoDownload: function () {
      var VueScrollTo = require('vue-scrollto')
      var options = {
        container: $('body')[0],
        easing: 'ease-out',
        offset: -170,
        force: true,
        cancelable: true,
        onStart: function (element) {
          // scrolling started
          console.log('scrollto', element)
        },
        onDone: function (element) {
          console.log('onDone', element)
        },
        onCancel: function () {
          console.log('onCancel')
        },
        x: false,
        y: true
      }
      var element = $('#download')[0]
      if (element) {
        VueScrollTo.scrollTo(element, 500, options)
      }
    }
  },
  mounted () {
    Vue.prototype.$eventHub.$emit('ShowToolbar', false)
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Quicksand&display=swap');
</style>



// WEBPACK FOOTER //
// src/components/SasOne.vue